import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { NewFederationStepsComponent } from '../../components/new-federation-steps/new-federation-steps.component';
import { LayoutBaseComponent } from '../../../shared-module/layouts/layout-base/layout-base.component';
import { TopBarComponent } from '../../../shared-module/components/top-bar/top-bar.component';
import { FederationsStoreSelectors } from '../../../root-store/federations-store';
import { ActiveRouteService } from '../../../shared-module/services';

@Component({
	selector: 'new-federation-layout',
	templateUrl: './new-federation-layout.component.html',
	imports: [LayoutBaseComponent, NewFederationStepsComponent, TopBarComponent, RouterOutlet, AsyncPipe]
})
export class NewFederationLayoutComponent extends LayoutBaseComponent {
	protected store = inject(Store);
	private activeRouteService = inject(ActiveRouteService);

	currentStep$ = this.store.select(FederationsStoreSelectors.selectNewFederationStep);
	tenantTitle$ = this.activeRouteService.tenantTitle$;
}
